export default __webpack_public_path__ + "static/media/spark_48.ae798676.png";